import service from '@/services/cajas/caja'

const getDefaultState = () => ({
  caja: {
    name: '',
    status: 'INICIANDO', // ABIERTA - CERRADA
    state: true,
    limiteInferior: 0,
    limiteSuperior: 0,
    cuentaContable: null
  },
  status: [
    { value: 'ABIERTA', text: 'success' },
    {
      value: 'CERRADA',
      text: 'warning'
    },
    {
      value: 'FINALIZADA',
      text: 'danger'
    }
  ],

  list: [],
  pageInfo: {},
  totalRegistros: 0,
  currentRow: null,
  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.caja = { ...getDefaultState().caja }),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_LIST: (state, obj) => {
    state.list = [...new Set([...state.list.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.pageInfo = obj.pageInfo
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))
    state.saved = true
  },
  SET_CAJA: (state, obj) => {
    state.caja = obj
  }

  // DELETE_LIST: (state, { obj }) => {
  //   state.list = state.list.filter(e => e._id !== obj._id)
  // },
  // SAVE_CHANGES: (state, obj) => {
  //   state.caja = obj
  //   state.saved = false
  // }
}

export const actions = {
  resetList: ({ state }) => {
    state.list = []
    state.pageInfo = {}
  },
  resetCaja: ({ commit }) => commit('RESET'),
  create: async ({ commit, rootGetters, state, dispatch }) => {
    const { userSession, createdAt, updatedAt, ...current } = state.caja

    current.limiteInferior = Number(current.limiteInferior)
    current.limiteSuperior = Number(current.limiteSuperior)

    return service
      .create({
        ...current,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        // if (state.list.length)
        commit('UPDATE_LIST', {
          ...current,
          _id: result._id
        })

        state.caja._id = result._id

        return result
      })
  },
  readTotal: async ({ state, rootGetters }) =>
    service.readTotal(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      state.totalRegistros = response
    }),

  readBySearchString: async ({ state, rootGetters }, { searchString }) =>
    service.readBySearchString(rootGetters['facturacion/emisorStore/get_Id'], searchString),

  // readByStatus: async ({ commit, rootGetters }, { status, caja }) =>
  //   service.readByStatus(rootGetters['facturacion/emisorStore/get_Id'], caja, status).then(response => {
  //     commit('SET_ONLINE_LIST', response)
  //     return response
  //   }),

  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetList')

    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit, filter).then(response => {
      return commit('SET_LIST', response)
    })
  },

  readById: async ({ commit }, { _id }) =>
    service.readById(_id).then(response => {
      commit('SET_CAJA', response)
      return response
    })

  // delete: ({ commit }, { items }) =>
  //   service.delete(items).then(result => {
  //     result.forEach(i => {
  //       if (i.state) commit('DELETE_LIST', { obj: i })
  //     })
  //     return result
  //   }),
  // saveChanges: ({ commit }, input) => commit('SAVE_CHANGES', input)
}

export const getters = {
  cajaStatus: state => value => {
    const status = state.status.find(e => e.value === value)

    return status?.text || 'info'
  }
}
